import { Route, Routes } from "react-router-dom";
import { useSelector } from "react-redux";

import LogInPage from "../Pages/LogIn/Login_Page";
import SideBar from "../SideBar/side";
import CompanyPage from "../Pages/Company/Company";
import DashboardPage from "../Pages/DashboardPage/Dashboard_Page";
import CreateCompanyForm from "../Pages/CreateCompany/Create_Company";
import ConfigurationPage from "../Pages/Configuration/ConfigWrap";
import Company from "../Pages/Company/Company";
import ViewCompany from "../Pages/ViewCompany/ViewCompany";
import Admin from "../Pages/Admin/Admin";
import CreateAdminForm from "../Pages/CreateAdmin/Create_Admin";
// ==============================|| ROUTING RENDER ||============================== //

const ThemeRoutes = () => {
  // return useRoutes([MainRoutes, AuthenticationRoutes]);
  return (
    <Routes>
      <Route exact path="/" element={<LogInPage />} />
      <Route element={<SideBar />}>
        <Route exact path="/dashboard" element={<DashboardPage />} />
        <Route
          exact
          path="/configuration/:companyid"
          element={<ConfigurationPage />}
        />
        <Route exact path="/createcompany" element={<CreateCompanyForm />} />
        <Route exact path="/create-admin" element={<CreateAdminForm />} />
        <Route
          exact
          path="/view-company/:companyid"
          element={<ViewCompany />}
        />
        <Route exact path="/companies" element={<Company />} />
        <Route exact path="/admins" element={<Admin />} />
      </Route>
    </Routes>
  );
};

export default ThemeRoutes;
